import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {priorityFilter} from "../../../utils/filters";
import {remoteOptionFormatter} from "../../../utils/formatters";

class authorList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "authorList"}
                {...props}
                columns={{
                    "name": {header: 'Név', width: 10, sortable, filterable},
                    ...(this.props.componentConfig.fielddefs.order ? {"order": {header: 'Kiemelés', width: 2, sortable, filterable: priorityFilter(), renderer: remoteOptionFormatter("priority_value")}} : {}),
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default authorList;
